var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIoPlanTypes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0468 38H7.95319C6.87614 38 6 37.1451 6 36.0942V3.90588C6 2.85492 6.87614 2 7.95319 2H32.0468C33.1239 2 34 2.85492 34 3.90588V36.0942C34 37.1451 33.1239 38 32.0468 38ZM7.95319 2.70012C7.27156 2.70012 6.7175 3.24076 6.7175 3.90588V36.0942C6.7175 36.7593 7.27156 37.2999 7.95319 37.2999H32.0468C32.7285 37.2999 33.2825 36.7593 33.2825 36.0942V3.90588C33.2825 3.24076 32.7285 2.70012 32.0468 2.70012H7.95319Z",
    fill: "#F4F4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5454 12.9091V17.0454",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3273 8.18176H16.7637C16.2415 8.18176 15.8182 8.60506 15.8182 9.12722V11.9636C15.8182 12.4857 16.2415 12.909 16.7637 12.909H24.3273C24.8495 12.909 25.2728 12.4857 25.2728 11.9636V9.12722C25.2728 8.60506 24.8495 8.18176 24.3273 8.18176Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2727 17.6364H28.8182",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5182 20H11.2091C10.8175 20 10.5 20.3175 10.5 20.7091V24.0182C10.5 24.4098 10.8175 24.7273 11.2091 24.7273H14.5182C14.9098 24.7273 15.2273 24.4098 15.2273 24.0182V20.7091C15.2273 20.3175 14.9098 20 14.5182 20Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2455 20H18.9364C18.5448 20 18.2273 20.3175 18.2273 20.7091V24.0182C18.2273 24.4098 18.5448 24.7273 18.9364 24.7273H22.2455C22.6371 24.7273 22.9546 24.4098 22.9546 24.0182V20.7091C22.9546 20.3175 22.6371 20 22.2455 20Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9728 20H26.6637C26.2721 20 25.9546 20.3175 25.9546 20.7091V24.0182C25.9546 24.4098 26.2721 24.7273 26.6637 24.7273H29.9728C30.3644 24.7273 30.6819 24.4098 30.6819 24.0182V20.7091C30.6819 20.3175 30.3644 20 29.9728 20Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0909 28.2727H30",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0909 31.8182H25.2728",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoPlanTypes);
export default __webpack_public_path__ + "static/media/IOPlanTypes.18597fbf4eb09d4fa8d95f704403fff3.svg";
export { ForwardRef as ReactComponent };